import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import AsyncSelect from "react-select/async";
import { useLazySearchUsersQuery } from "@/api/users-admin";
import { SelectComponents } from "./formSelectUsersComponents";

interface Props {
  isReadOnly: boolean;
}
export const ShareModalUserFormSelectUsers: React.FC<Props> = ({ isReadOnly }) => {
  const { control } = useFormContext();

  const [fetchUsers] = useLazySearchUsersQuery();

  const loadOptions = async (query: string) => fetchUsers(query).unwrap();

  return (
    <Controller
      name="users"
      control={control}
      render={({ field }) => (
        <AsyncSelect
          isDisabled={isReadOnly}
          styles={{
            input: base => ({
              ...base,
              "input:focus": {
                boxShadow: "none",
              },
            }),
            valueContainer: provided => ({ ...provided, display: "flex" }),
          }}
          placeholder="Select user to share"
          isSearchable={true}
          isClearable={true}
          isMulti={true}
          loadOptions={loadOptions}
          noOptionsMessage={noOptionMessage}
          components={SelectComponents}
          {...field}
        />
      )}
    />
  );
};

const noOptionMessage = () => "No data";
